import useRoles from "@/hooks/useRoles";
import { useSelector } from "react-redux";

export const useIsChatEnabled = () => {

    const isChatEnabled = useSelector((store: any) => store.settings.isChatEnabled==='1');
    
    const disableChatForChildren = useSelector((store: any) => store.settings.disableChatForChildren === '1');
    const disableChatForEmployee = useSelector((store: any) => store.settings.disableChatForEmployee === '1');
    const disableChatForParent = useSelector((store: any) => store.settings.disableChatForParent === '1');
    
    const {isChildren, isEmployee, isParent} = useRoles();

    
    const isChatFloatingIconEnabled = isChatEnabled && (
        (isChildren && !disableChatForChildren) ||
        (isEmployee && !disableChatForEmployee) ||
        (isParent && !disableChatForParent)
    );

    return {
        isChatEnabled,
        isChatFloatingIconEnabled,
    }


}
